import {Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import * as fromTeamsSelectors from '../../../store/team/team.selectors';
import { Store } from '@ngrx/store';
import { TeamState } from 'src/app/modules/store/team/team.reducer';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionList } from '../../../shared/models/asp.types';
import { unsubscribeSubscriptions } from '../../../shared/services/util.service';

@Component({
  selector: 'app-team-dialog',
  templateUrl: './team-dialog.component.html',
  styleUrls: ['./team-dialog.component.scss']
})
export class TeamDialogComponent implements OnInit, OnDestroy {
  title: string = this.translate.instant('teamManagement.addNewTeam');
  actionText: string =  this.translate.instant('scheduleRotation.add');
  isEditMode = false;
  colors = ['#E6F0FF', '#FDEB9B', '#E1BBE8', '#AED5EB', '#B4D1FF', '#F2E0FF', '#FFEAD3', '#FFE8E8', '#F4B8B2', '#FFC9DE', '#C9FFF5', '#CEFFE6', '#FFFCD3', '#FFDCA3', '#E5FFE9','#D9E2E2'];
  teamForm: UntypedFormGroup;
  teamColors$ : Observable<string[]>;
  selectedColors: string[] = [];
  isSelectedColor: boolean = false;
  clickedOutside=false;
  @ViewChild('form') form: ElementRef;
  private subs: SubscriptionList = {};

  constructor(
    private readonly teamsState: Store<TeamState>,
    private translate: TranslateService,
    private readonly formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<TeamDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.teamForm = this.formBuilder.group({
      name: ['', Validators.required],
      teamColor: ['', Validators.required]
    });
    this.teamColors$ = this.teamsState.select(fromTeamsSelectors.selectTeamColors);
   this.subs.teamColors = this.teamColors$.subscribe(data => {
      this.selectedColors = data;
    });
    this.setUpEditMode();

  }

  @HostListener("document:click", ['$event.target'])
  showMessage(event)
  {    
    if (!this.form.nativeElement.contains(event) )
    {
      if(this.data.clicked) {
        this.data.clicked=false;
      }
      else{
        this.clickedOutside=true;
      }
    }
  }

  close() {
    this.dialogRef.close({action: 'cancel'});
  }

  onActionClicked() {
    this.dialogRef.close({action: 'confirm', data: this.teamForm.value});
  }

  setTeamColor(colorVal: string){
    if(!this.selectedColors.includes(colorVal) ||(this.data && colorVal === this.data?.teamColor )){
    this.teamForm.get('teamColor').patchValue(colorVal);
    this.isSelectedColor = false;
    } else {
      this.isSelectedColor = true;
    }
  }

  private setUpEditMode() {
    this.isEditMode = !!this.data?.team;
    if (this.isEditMode) {
      this.teamForm.patchValue(this.data.team);
      this.title = this.translate.instant('teamManagement.editTeamDetails');
      this.actionText = this.translate.instant('teamManagement.update');
    }
  }
  checkTeamName(event){
    if(event.target.value?.toLowerCase() === 'txm'){
      this.teamForm.get('name').setErrors({nameInvalid:'Team name can not be in any form of TXM'});
    }
    else{
        this.teamForm.get('name').setErrors(null, {emitEvent: false});
    }
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }
}
